module.exports = __webpack_public_path__ + "img/20220413_122943.775a335e.jpg";